/* eslint-disable object-shorthand */
/* eslint-disable react/style-prop-object */
import anime from 'animejs/lib/anime.es';
import Box from '@ui-kit/box';
import { useEffect } from 'preact/hooks';

function VerifyIdentityAnimation() {
  const verifyAnimation = anime.timeline({
    autoplay: true,
    loop: false,
  });

  useEffect(() => {
    verifyAnimation
      .add({
        targets: '#id-card',
        translateY: [20, 0],
        opacity: [0, 1],
        duration: 1000,
      })
      .add({
        targets: '#id-photo',
        translateY: [5, 0],
        opacity: [0, 1],
        duration: 1000,
      }, 400)
      .add({
        targets: '#id-info-bars',
        translateY: [10, 0],
        opacity: [0, 1],
        duration: 1000,
      }, '-=900')
      .add({
        targets: '#id-corners',
        scale: [0.75, 1],
        opacity: [0, 1],
        duration: 1000,
        easing: 'spring(1, 80, 10, 0)',
      }, 900)
      .add({
        targets: '#scan-bar',
        opacity: [0, 1],
        duration: 500,
      }, 1000)
      .add({
        targets: '#scan-bar',
        translateX: [0, 60],
        duration: 450,
      }, '-=200')
      .add({
        targets: '#scan-bar',
        translateX: [60, 0],
        opacity: [0, 1],
        duration: 450,
      })
      .add({
        targets: '#scan-bar, #id-corners',
        opacity: [1, 0],
        duration: 450,
      })
      .add({
        targets: '#id-photo, #id-info-bars, #id-card',
        opacity: [1, 0],
        translateY: 100,
        easing: 'easeOutSine',
        duration: 450,
        delay: anime.stagger(100),
      }, '+=200')
      .add({
        targets: '#user-circle',
        scale: [0.5, 1],
        opacity: [0, 1],
        duration: 900,
        easing: 'spring(1, 80, 10, 0)',
      }, '-=400')
      .add({
        targets: '#user-blue-check',
        scale: [0.5, 1.25],
        opacity: [0, 1],
        duration: 900,
        easing: 'spring(1, 80, 10, 0)',
      }, '-=800');
    verifyAnimation.play();
  }, []);

  return (
    <Box position="relative">
      <svg width="93px" height="93px" viewBox="0 0 93 93" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Artboard-Copy-2" transform="translate(-19.000000, -12.000000)">
            <g id="Group-2" transform="translate(19.000000, 12.000000)">
              {/* USER CIRCLE */}
              <g id="user-circle" style="transform-box: fill-box; transform-origin: 50% 50%; opacity: 0;">
                <g transform="translate(11.000000, 11.000000)">
                  <circle id="Oval-Copy" fill="#392E8B" cx="35.5" cy="35.5" r="35.5" />
                  <circle id="Oval-Copy" fill="#705DFF" cx="36" cy="36" r="29" />
                  <g id="Group" transform="translate(21.000000, 21.000000)" fill="#392E8B">
                    <ellipse id="Oval-Copy" cx="14.5" cy="7.425" rx="7.5952381" ry="7.425" />
                    <path d="M0,27 C9.99317954,14.5751534 19.7331492,12.897348 29,27 L0,27 Z" id="Path-7-Copy" />
                  </g>
                </g>
              </g>
              {/* USER CHECK */}
              <g id="user-blue-check" style="transform-box: fill-box; transform-origin: 50% 50%; opacity: 0;">
                <g transform="translate(61.000000, 16.000000)">
                  <path d="M7.0282553,2.0264639 L9.85972659,0.764032443 L12.3407063,2.64436459 L14.1917025,2.87074144 L15.5569156,3.02388512 L16.0338653,4.05898889 L18.0026886,8.99072758 L17.8310517,10.5944246 L16.5241632,12.3014211 L16.0338653,14.3604553 L15.8416322,15.6493085 C14.7416791,15.9659603 14.1917025,16.1242862 14.1917025,16.1242862 C14.1917025,16.1242862 13.4328861,16.2822003 11.9152532,16.5980286 L10.6455073,17.5818106 L8.53776852,17.871329 L7.40184053,17.1009773 L5.6255086,16.1242862 L3.39761575,15.6493085 L2.80654144,14.3604553 L2.51326323,12.3014211 L1.33866151,10.4650642 L0.784657319,8.99072758 L1.75534773,7.83660578 L3.00258271,5.95213174 L3.00258271,4.05898889 L3.39761575,3.02388512 L4.3933719,2.87074144 L6.32656558,2.87074144 L7.0282553,2.0264639 Z" id="Path-4" fill="#006DFF" />
                  <path d="M7.94722147,18.4432566 L6.55126711,17.2413955 C6.40990464,17.1176746 6.05649846,16.9939531 5.87096022,16.9939531 L4.35131339,16.9939531 C3.04371049,16.9939531 1.9834921,15.9334877 1.9834921,14.6255807 L1.9834921,13.1144187 C1.9834921,12.9288373 1.85980007,12.584186 1.7361079,12.4427906 L0.543362005,11.0376742 C-0.181120668,10.1804649 -0.181120668,8.82837252 0.543362005,7.97116319 L1.7361079,6.56604677 C1.85980007,6.42465143 1.9834921,6.08000005 1.9834921,5.89441866 L1.9834921,4.37441843 C1.9834921,3.06651143 3.04371049,2.00604648 4.35131339,2.00604648 L5.87979516,2.00604648 C6.0653334,2.00604648 6.41874,1.87348836 6.56010247,1.75860465 L7.95605683,0.556744169 C8.821902,-0.18558139 10.1736804,-0.18558139 11.0395256,0.556744169 L12.43548,1.75860465 C12.5768424,1.88232558 12.930249,2.00604648 13.1157873,2.00604648 L14.6177634,2.00604648 C15.9253663,2.00604648 16.9855851,3.06651143 16.9855851,4.37441843 L16.9855851,5.87674426 C16.9855851,6.06232565 17.1181132,6.41581402 17.2418054,6.55720936 L18.4433853,7.95348836 C19.1855382,8.81953489 19.1855382,10.1716277 18.4433853,11.0376742 L17.2418054,12.4339532 C17.1181132,12.5753486 16.9855851,12.9288373 16.9855851,13.1144187 L16.9855851,14.616745 C16.9855851,15.924652 15.9253663,16.9851157 14.6177634,16.9851157 L13.1157873,16.9851157 C12.930249,16.9851157 12.5768424,17.1176744 12.43548,17.2325581 L11.0395256,18.4344191 C10.606603,18.8144192 10.0499883,19 9.49337354,19 C8.9367588,19 8.38014406,18.8144193 7.94722147,18.4432566 Z M3.30876529,4.37441843 L3.30876529,5.88558125 C3.30876529,6.38930218 3.07021624,7.03441889 2.74331552,7.4144189 L1.55056962,8.81953447 C1.24133921,9.18186005 1.24133921,9.80930252 1.55056962,10.1716281 L2.74331552,11.5767445 C3.07021624,11.9655817 3.30876529,12.6018604 3.30876529,13.1055813 L3.30876529,14.616745 C3.30876529,15.1911636 3.77702836,15.6595343 4.35131339,15.6595343 L5.87979516,15.6595343 C6.39223411,15.6595343 7.03720042,15.8981403 7.42594722,16.2339542 L8.82190158,17.4358135 C9.18414292,17.7451159 9.82027402,17.7451159 10.1825154,17.4358135 L11.5784697,16.2339542 C11.9672165,15.9069775 12.6121837,15.6595343 13.1246226,15.6595343 L14.6265987,15.6595343 C15.2008838,15.6595343 15.6691473,15.1911636 15.6691473,14.616745 L15.6691473,13.1144187 C15.6691473,12.6018606 15.9076961,11.9567443 16.243432,11.5679071 L17.4450135,10.1716281 C17.754244,9.80930252 17.754244,9.17302348 17.4450135,8.8106979 L16.243432,7.4144189 C15.9076961,7.02558169 15.6691473,6.38046497 15.6691473,5.86790685 L15.6691473,4.37441843 C15.6691473,3.79999984 15.2008838,3.33162788 14.6265987,3.33162788 L13.1246226,3.33162788 C12.6121837,3.33162788 11.9672165,3.09302314 11.5784697,2.75720919 L10.1825154,1.55534882 C9.82027402,1.2460465 9.18414292,1.2460465 8.82190158,1.55534882 L7.42594722,2.7660466 C7.03720042,3.09302335 6.38339896,3.33162788 5.87979516,3.33162788 L4.35131339,3.33162788 C3.77702836,3.33162788 3.30876529,3.79999984 3.30876529,4.37441843 Z" id="Vector" fill="#006DFF" />
                  <path d="M7.95578067,12.1070023 L5.81767321,9.96839734 C5.56145374,9.71211828 5.56145374,9.28793269 5.81767321,9.03165363 C6.07389269,8.77537457 6.49797963,8.77537457 6.75419911,9.03165363 L8.42404363,10.7018859 L12.2231605,6.90188635 C12.47938,6.64560729 12.9034665,6.64560729 13.159686,6.90188635 C13.4159055,7.15816541 13.4159055,7.58235097 13.159686,7.83863004 L8.89230659,12.1070023 C8.76861443,12.2307232 8.60074673,12.3014211 8.42404363,12.3014211 C8.24734054,12.3014211 8.07947284,12.2307232 7.95578067,12.1070023 Z" id="Vector" fill="#FAFAFA" fillRule="nonzero" />
                </g>
              </g>
              {/* ID CARD */}
              <rect id="id-card" fill="#5620CA" x="14" y="25" width="65" height="41" rx="4" style="transform-box: fill-box; transform-origin: 50% 50%; opacity: 0;" />
              {/* ID PHOTO */}
              <g id="id-photo" style="transform-box: fill-box; transform-origin: 50% 50%; opacity: 0;">
                <g transform="translate(19.000000, 31.000000)">
                  <rect id="Rectangle" fill="#705DFF" x="0" y="0" width="25" height="29" rx="2" />
                  <circle id="Oval" fill="#392E8B" cx="12.5" cy="11.5" r="5.5" />
                  <path d="M2,26 C9.23644035,16.7964099 16.2895218,15.5535911 23,26 L2,26 Z" id="Path-7" fill="#392E8B" />
                </g>
              </g>
              {/* ID INFO */}
              <g id="id-info-bars" style="transform-box: fill-box; transform-origin: 50% 50%; opacity: 0;">
                <g style="transform-box: fill-box; transform-origin: 50% 50%;">
                  <g transform="translate(48.000000, 38.000000)" fill="#705DFF">
                    <rect id="Rectangle" x="0" y="0" width="26" height="3" />
                    <rect id="Rectangle-Copy" x="0" y="7" width="26" height="3" />
                    <rect id="Rectangle-Copy-2" x="0" y="14" width="26" height="3" />
                  </g>
                </g>
              </g>
              {/* ID SCAN BAR */}
              <path d="M19.24,2 C19.3630806,2 19.4645217,2.0922145 19.4783853,2.21101518 L19.48,2.23887279 L19.48,90.7611272 C19.48,90.893053 19.3725483,91 19.24,91 C19.1169194,91 19.0154783,90.9077855 19.0016147,90.7889848 L19,90.7611272 L19,2.23887279 C19,2.10694699 19.1074517,2 19.24,2 Z" id="scan-bar" fill="#355DFF" fillRule="nonzero" style="opacity: 0;" />
              <g id="id-corners" style="transform-box: fill-box; transform-origin: 50% 50%; opacity: 0;">
                <g transform="translate(7.000000, 18.000000)" stroke="#5620CA" strokeWidth="0.5">
                  <g id="Group" transform="translate(55.000000, 0.000000)">
                    <polyline id="Path-5-Copy-5" points="0 0 24 0 24 21" />
                    <polyline id="Path-5-Copy-6" transform="translate(12.000000, 44.500000) scale(1, -1) translate(-12.000000, -44.500000) " points="0 34 24 34 24 55" />
                  </g>
                  <g id="Group" transform="translate(12.000000, 27.500000) scale(-1, 1) translate(-12.000000, -27.500000) ">
                    <polyline id="Path-5-Copy-5" points="0 0 24 0 24 21" />
                    <polyline id="Path-5-Copy-6" transform="translate(12.000000, 44.500000) scale(1, -1) translate(-12.000000, -44.500000) " points="0 34 24 34 24 55" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}

export default VerifyIdentityAnimation;
